// @flow

import Service from "app/services/Service";

class VideoService extends Service {
    static base = "/video";

    validate(data): Promise<*> {
        return this.http.post("validate", data);
    }

    resolveByUrl(url: string): Promise<*> {
        return this.http.get("byUrl/" + url);
    }

    publish(uid: string): Promise<*> {
        return this.http.put(uid + "/publish");
    }

    report(uid: string, message: string): Promise<*> {
        return this.http.post(
            uid + "/report",
            this.toSearchParams({ message })
        );
    }

    create(url: string, tags: string[], unlisted: boolean): Promise<*> {
        const t = tags.join(",");
        return this.http.post(
            "",
            this.toSearchParams({ url: url, tags: t, private: unlisted })
        );
    }

    updateTitle(uid: string, title: string): Promise<*> {
        return this.http.post(uid + '/title', this.toFormData({title}));
    }

    updateFolder(uid: string, folder_id: string): Promise<*> {
        return this.http.post(uid + '/folder', this.toFormData({folder_id}));
    }

    delete(uid: string): Promise<*> {
        return this.http.delete(uid);
    }

    selectUseCase(uid: string, category: string): Promise<*> {
        return this.http.put(uid + "/use-case/" + category);
    }

    updateUseCaseMetadata(
        uid: string,
        property: string,
        value: string
    ): Promise<*> {
        return this.http.put(
            uid + "/use-case-metadata/" + property,
            this.toSearchParams({ value })
        );
    }

    highlightUseCase(uid: string): Promise<*> {
        return this.http.put(uid + "/highlight-use-case");
    }

    setHomepage(uid: string, checked: boolean): Promise<*> {
        const value = checked ? 1 : 0;
        return this.http.put(`${uid}/homepage/${value}`);
    }
}

export default new VideoService();



// WEBPACK FOOTER //
// ./src/app/services/VideoService.js